import { Component, OnInit } from '@angular/core';
import { MenutitleService } from '../menutitle.service';

@Component({
  selector: 'app-menutitle',
  templateUrl: './menutitle.component.html',
  styleUrls: ['./menutitle.component.css']
})
export class MenutitleComponent implements OnInit {

  message:string;

  pinkheader: boolean;

  constructor(private data: MenutitleService) { }

  ngOnInit() {
    this.data.currentMessage.subscribe(message => this.message = message)
    this.data.currentHeaderColor.subscribe(pinkheader => this.pinkheader = pinkheader)
    //this.pinkHeader = false;
  }

}
